import { render, staticRenderFns } from "./Habilitaciones.vue?vue&type=template&id=74f7b8d2&"
import script from "./Habilitaciones.vue?vue&type=script&lang=js&"
export * from "./Habilitaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports